'use client'

import { cn } from '@/lib/utils'
import { motion } from 'framer-motion'

type Props = {
  className?: string
}

export default function Loading({ className }: Props) {
  return (
    <div className={cn(className ? className : 'flex items-center min-h-screen justify-center')}>
      <div className='relative h-40 w-40'>
        <svg
          className='absolute inset-0'
          viewBox='0 0 100 100'
          xmlns='http://www.w3.org/2000/svg'
        >
          <defs>
            <linearGradient
              id='boltGradient'
              x1='0%'
              y1='0%'
              x2='100%'
              y2='100%'
            >
              <stop
                offset='0%'
                stopColor='#4facfe'
              />
              <stop
                offset='100%'
                stopColor='#00f2fe'
              />
            </linearGradient>
          </defs>
          <motion.path
            d='M48.5833 7.91667L13.4167 55.4167H45.8333L41.25 92.0833L76.4167 44.5833H44L48.5833 7.91667Z'
            fill='none'
            stroke='url(#boltGradient)'
            strokeWidth='4'
            strokeLinecap='round'
            strokeLinejoin='round'
            initial={{ pathLength: 0, opacity: 0 }}
            animate={{ pathLength: 1, opacity: 1 }}
            transition={{
              duration: 2,
              ease: 'easeInOut',
              repeat: Infinity,
              repeatType: 'loop',
            }}
          />
        </svg>
        <motion.div
          className='absolute inset-0 rounded-full bg-blue-500 opacity-20'
          animate={{
            scale: [1, 1.2, 1],
            opacity: [0.2, 0.4, 0.2],
          }}
          transition={{
            duration: 2,
            ease: 'easeInOut',
            repeat: Infinity,
          }}
        />
        <motion.div
          className='absolute inset-4 rounded-full bg-blue-400 opacity-20'
          animate={{
            scale: [1, 1.1, 1],
            opacity: [0.2, 0.3, 0.2],
          }}
          transition={{
            duration: 2,
            ease: 'easeInOut',
            repeat: Infinity,
            delay: 0.5,
          }}
        />
      </div>
    </div>
  )
}
